import React from 'react';
import PropTypes from 'prop-types';
import Icon from './icon';
import * as styles from './whats-nearby-item.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var WhatsNearbyItem = props => ___EmotionJSX("div", {
  css: styles.nearbyItem
}, ___EmotionJSX("div", {
  css: styles.iconContainer
}, props.iconName && ___EmotionJSX(Icon, {
  name: props.iconName,
  size: "custom",
  css: styles.icon
}), !props.iconName && ___EmotionJSX("span", {
  css: styles.iconPlaceholder
})), ___EmotionJSX("div", {
  css: styles.details
}, ___EmotionJSX("span", {
  css: styles.name
}, props.name), ___EmotionJSX("span", {
  css: styles.type
}, props.type)), ___EmotionJSX("div", {
  css: styles.distance
}, props.distance, "km"));
WhatsNearbyItem.propTypes = {
  iconName: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  distance: PropTypes.number.isRequired
};
WhatsNearbyItem.defaultProps = {
  iconName: null
};
export default WhatsNearbyItem;